export default "__VITE_ASSET__ab710923__"